import {ValueObject} from '@s-ui/domain'

export class CanonicalValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static create({value}) {
    return new CanonicalValueObject({value})
  }

  static createFromApi({config, canonical, url}) {
    const {SEMANTIC_KEYWORDS} = config.get('seo')
    const isRenting = url.startsWith('/renting/')
    if (isRenting) {
      const CANONICAL_SEMANTIC_KEYWORDS = {
        ...SEMANTIC_KEYWORDS.RENTING,
        // We remove 'cheap' and vehicleTypeVan from the list because it is already handled by semantics at canonical level
        CHEAP: undefined,
        VEHICLE_TYPE_VAN: undefined
      }
      const matchedKeys = Object.values(CANONICAL_SEMANTIC_KEYWORDS).filter(keyword => url.includes(keyword))
      if (matchedKeys.length !== 0) {
        const rentingCanonicalUrl = `${canonical}${matchedKeys.join('/')}/`
        return new CanonicalValueObject({value: rentingCanonicalUrl})
      }
    }
    return new CanonicalValueObject({value: canonical})
  }

  get value() {
    return this.#value
  }
}
